import ApiBudgety from '@/api/apiBudgety'

export const tipoPresupuestoService = {
  getTiposPresupuestos,
}

async function getTiposPresupuestos() {
  return await ApiBudgety.get('TipoPresupuesto/GetAll')
}
